var _title, _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from 'react';
const SvgComponent = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: "51px",
  height: "55px",
  viewBox: "0 0 51 55",
  version: 1.1,
  xmlnsXlink: "http://www.w3.org/1999/xlink"
}, props), _title || (_title = /*#__PURE__*/React.createElement("title", null, `Group`)), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  x1: "38.6274823%",
  y1: "-5.26315789e-06%",
  x2: "88.6786391%",
  y2: "56.1621053%",
  id: "linearGradient-1"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#ADCEFF",
  offset: "0%"
}), /*#__PURE__*/React.createElement("stop", {
  stopColor: "#E1EDFF",
  offset: "52.6042%"
}), /*#__PURE__*/React.createElement("stop", {
  stopColor: "#FAFCFF",
  offset: "100%"
})))), _g || (_g = /*#__PURE__*/React.createElement("g", {
  id: "Final-Design",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "Aura-Integration-Card-V1.1---High-fidelity",
  transform: "translate(-126, -293)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group-6",
  transform: "translate(96, 269)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group",
  transform: "translate(30, 24)"
}, /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle",
  fill: "url(#linearGradient-1)",
  fillRule: "nonzero",
  x: 0,
  y: 0,
  width: 51,
  height: 54.3874346,
  rx: 9
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle",
  fill: "url(#linearGradient-1)",
  fillRule: "nonzero",
  x: 0,
  y: 0,
  width: 51,
  height: 54.3874346,
  rx: 9
}), /*#__PURE__*/React.createElement("path", {
  d: "M20.2766605,13.8232821 L30.7297816,13.8232821 L30.7297816,16.4972833 L20.2766605,16.4972833 L20.2766605,13.8232821 Z M17.5472211,40.5638662 L24.2565395,21.8455718 L26.7386289,21.8455718 L33.4480816,40.5638662 L30.7625289,40.5638662 L25.4975842,25.8756807 L20.2327737,40.5638662 L17.5472211,40.5638662 Z",
  id: "Shape",
  fill: "#191C1F"
})))))));
export default __webpack_public_path__ + "static/media/aura-logo.0fee1c2c.svg";
export { SvgComponent as ReactComponent };